module.exports = function () {

    let module = {};

    module.environment = process.env.NODE_ENV;
    module.isLive = (module.environment == 'production') ? true : false;
    module.isStaging = (module.environment == 'staging') ? true : false;
    module.isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? true : false;


    module.log = function (message) {
        if (!module.isStaging && !module.isLive)
            return console.log(message);
    };

    // Only include Bootstrap modules required
    module.initBootstrap = function () {
        require('bootstrap/js/dist/index');
        require('bootstrap/js/dist/alert');
        require('bootstrap/js/dist/button'); // required for auto complete library
        //require('bootstrap/js/dist/carousel');
        require('bootstrap/js/dist/collapse');
        require('bootstrap/js/dist/dropdown');
        require('bootstrap/js/dist/modal');
        // require('bootstrap/js/dist/popover');
        // require('bootstrap/js/dist/scrollspy');
        require('bootstrap/js/dist/tab');
        // require('bootstrap/js/dist/tooltip');
        // require('bootstrap/js/dist/util');
    };

    // module.initDatepicker = function () {
    //     require('jquery-ui/ui/keycode');
    //     require('jquery-ui/ui/widgets/datepicker');
    //
    //     $('.datepicker').datepicker({
    //         dateFormat: "d MM yy",
    //         changeMonth: true,
    //         changeYear: true,
    //         maxDate: "-18y"
    //     });
    // }


    module.initLazyLoad = function () {
        const lasysizes = require('lazysizes/lazysizes');
        lazySizes.cfg.lazyClass = 'lazy';
    };

    module.initRrssb = function () {
        require('rrssb');
    };

    module.initPopups = function () {
        if ($('#popupModal').length) {
            let id = $('#popupModal').data('id');
            let popupShown = localStorage.getItem('popup-' + id + '-shown');
            let expirationDate = localStorage.getItem('popup-' + id + '-expiration');

            // Check if the popup has been shown and if the expiration date has passed
            if (!popupShown || Date.now() > parseInt(expirationDate)) {
                let delay = parseInt($('#popupModal').data('delay') + '000');
                let next_display_time = parseInt($('#popupModal').data('next-display-time'));
                const expirationTime = Date.now() + (next_display_time ? next_display_time : 7) * 24 * 60 * 60 * 1000; // Current time + 7 days in milliseconds

                setTimeout(function () {
                    $('#popupModal').modal('show');
                    localStorage.setItem('popup-' + id + '-shown', 'true');
                    localStorage.setItem('popup-' + id + '-expiration', expirationTime.toString());
                }, delay ? delay : 2000);
            }
        }
    };

    module.keepTokenAlive = function () {

        // To override the default mins, add a <body> data tag value for 'token_minutes'
        let keepAlive = $('body').data('token-minutes');

        setInterval(keepTokenAlive, 1000 * 60 * (keepAlive ? keepAlive : 3)); // every 3 or x mins

        function keepTokenAlive() {
            $.ajax({
                url: '/keep-token-alive', //https://stackoverflow.com/q/31449434/470749
                method: 'post',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            }).then(function (result) {
                console.log(new Date() + ' ' + result + ' ' + $('meta[name="csrf-token"]').attr('content'));
            });
        }
    }

    module.initTooltips = function () {

        $('[data-toggle="tooltip"]').tooltip({
            trigger: 'hover focus',
            placement: 'bottom',
            container: 'body'
        });
    };


    module.initStickyEl = function () {
        // Select the sticky nav element and its offset
        let el = $('.is-sticky');
        let stickyOffset = el.offset().top; // Get initial offset of the sticky element

        // Use requestAnimationFrame for smoother scroll handling
        let isScrolling = false;

        window.addEventListener('scroll', function () {
            if (!isScrolling) {
                window.requestAnimationFrame(function () {
                    module.addStickyClass(stickyOffset); // Pass the sticky element's original offset
                    isScrolling = false;
                });
            }
            isScrolling = true;
        });

        module.addStickyClass(stickyOffset); // Trigger on page load
    };

    module.addStickyClass = function (stickyOffset) {
        let body = $('body');
        let yOffset = window.pageYOffset; // Get current scroll position

        // Check if user has scrolled past the original position of the nav
        if (yOffset >= stickyOffset) {
            body.addClass("stuck").removeClass("before-stuck");
        } else {
            body.removeClass("stuck").addClass("before-stuck");
        }
    };


    // module.navDropdownHover = function () {
    //
    //     const $dropdown = $(".dropdown");
    //     const $dropdownToggle = $(".dropdown-toggle");
    //     const $dropdownMenu = $(".dropdown-menu");
    //     const showClass = "show";
    //
    //     $(window).on("load resize", function() {
    //         if (this.matchMedia("(min-width: 768px)").matches) {
    //             $dropdown.hover(
    //                 function() {
    //                     const $this = $(this);
    //                     $this.addClass(showClass);
    //                     $this.find($dropdownToggle).attr("aria-expanded", "true");
    //                     $this.find($dropdownMenu).addClass(showClass);
    //                 },
    //                 function() {
    //                     const $this = $(this);
    //                     $this.removeClass(showClass);
    //                     $this.find($dropdownToggle).attr("aria-expanded", "false");
    //                     $this.find($dropdownMenu).removeClass(showClass);
    //                 }
    //             );
    //         } else {
    //             $dropdown.off("mouseenter mouseleave");
    //         }
    //     });
    // };


    module.announcementBarDismiss = function () {
        if ($('#announcement-dismiss').length) {
            $('#announcement-dismiss').click(function () {
                $.get("/announcement-dismiss", function () {
                    console.log("Announcement bar dismissed");
                    $('#announcement-dismiss').fadeOut(300);
                })
            });
        }
    };

    module.initSpotlightJs = function () {
        if ($('.spotlight').length)
            require('spotlight.js');
    };


    module.initTingleModalJs = function () {

        const Tingle = require('tingle.js');

        var modal = new Tingle.modal({
            stickyFooter: false,
            footer: false,
            closeMethods: ['overlay', 'button', 'escape'],
            cssClass: ['custom-class-1', 'custom-class-2'],
        });

        $('.md-trigger').click(function (event) {
            let id = $(this).data('id');
            modal.setContent($('#' + id).html());
            modal.open();
        });
    };

    module.initLightbox = function () {
        require('ekko-lightbox');
        $(document).on('click', '[data-toggle="lightbox"]', function (event) {
            event.preventDefault();
            $(this).ekkoLightbox({
                alwaysShowClose: true,
                leftArrow: '<i class="fa fa-chevron-left left"></i>',
                rightArrow: '<i class="fa fa-chevron-right right"></i>'
            });
        });
    };

    module.initMobileMenu = function () {
        require('../plugins/jquery-simple-mobile-menu');
        $(".mobile_menu").simpleMobileMenu();
        $('#sm_menu_ham').addClass('icon').prependTo('.mobile-icons');
    };

    module.initSlickCarousel = function () {
        require('@accessible360/accessible-slick');

        $('.slick.featured-testimonials').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            arrows: true,
            cssEase: 'ease-in-out',
            prevArrow: $('.testi-prev'),
            nextArrow: $('.testi-next'),
        });

        $('.slick.shortcode-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            fade: true,
            arrows: false,
            dots: true,
            cssEase: 'linear',
        });

        $('.slick.slides').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            arrows: false,
            dots: true,
        });

        $('.slick.carousel').slick({
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            draggable: false,
            responsive: [
                {
                    breakpoint: 968,
                    settings: {
                        slidesToShow: 1
                    }
                },
            ]
        });


        var $carousel = $('.slick-carousel.services').slick({
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            prevArrow: $('.service-prev'),
            nextArrow: $('.service-next'),
            responsive: [
                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 3.5,
                        centerPadding: '50px'
                    }
                },
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 2.4,
                        centerPadding: '100px'
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1.5,
                        centerPadding: '50px'
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1.2,
                        centerPadding: '10px'
                    }
                }
            ]
        });


        $('.service-titles .nav-link').on('click', function () {
            // Get the index number we defined in the markup
            var slideIndex = $(this).data('slide-index');

            // Tell Slick to scroll to that index
            $carousel.slick('slickGoTo', slideIndex);
        });


        $('.slick-carousel.research').slick({
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            variableWidth: false,
            //adaptiveHeight: false,
            arrows: true,
            dots: false,
            prevArrow: $('.research-prev'),
            nextArrow: $('.research-next'),

            responsive: [

                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 3.5,
                        centerPadding: '50px'
                    }
                },
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 2.4,
                        centerPadding: '100px'
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1.5,
                        centerPadding: '50px'
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1.2,
                        centerPadding: '10px'
                    }
                }
            ],

        });


        $('.slick-carousel.work').slick({
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            variableWidth: false,
            //adaptiveHeight: false,
            arrows: true,
            dots: false,
            prevArrow: $('.work-prev'),
            nextArrow: $('.work-next'),

            responsive: [

                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 3.5,
                        centerPadding: '50px'
                    }
                },
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 2.4,
                        centerPadding: '100px'
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1.5,
                        centerPadding: '50px'
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1.2,
                        centerPadding: '10px'
                    }
                }
            ],

        });

        $('.slick-carousel.logos').slick({
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            variableWidth: false,
            //adaptiveHeight: false,
            autoplay: true,
            autoplaySpeed: 1500,
            arrows: false,
            dots: true,
            appendDots: '.dots',

            responsive: [

                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 3.5,
                        centerPadding: '50px'
                    }
                },
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 2.4,
                        centerPadding: '100px'
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1.5,
                        centerPadding: '50px'
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1.2,
                        centerPadding: '10px'
                    }
                }
            ],

        });

    };


    module.scrollToAnchor = function () {
        $('a[href^=\\#scroll-]').on('click', function (e) {
            e.preventDefault();

            let collapseId = $(this).attr('href').replace('scroll-', '');

            console.log(collapseId);

            module.scrollToElement(collapseId);
        });
    };


    module.detectUrlScrollHash = function () {
        if (window.location.hash.indexOf('scroll-') == 1) {

            let el = window.location.hash.replace('scroll-', '');

            console.log('Attempting automatic scroll to ' + el);

            this.scrollToElement(el);
        }
    };

    module.scrollToElement = function (element) {
        console.log('Attempt to scroll to el ' + element);
        $('html,body').animate({scrollTop: $(element).offset().top - 100}, 'slow', function () {
            if ($(element).length && $(element).next().hasClass('collapse')) {
                $(element).next().collapse('show');
            }
        });
    };

    module.scrollToAccordionItem = function () {

        $('.accordion').on('shown.bs.collapse', function (event) {
            let getHeaderEl = $('#' + event.target.id).prev('.card-header').attr('id');

            if (getHeaderEl)
                module.scrollToElement('#' + getHeaderEl);
        });

    };

    module.initWowJs = function () {
        const {WOW} = require('wowjs');
        new WOW({
            mobile: false,
        }).init();
    };


    module.convertCryptedEmails = function () {

        $('.cryptedmail').each(function () {

            let
                el = $(this).find('span'),
                e = el.data('name') + '@' + el.data('domain') + '.' + el.data('tld');

            $(this).attr('href', 'mailto:' + e).removeClass('cryptedmail').find('span');

            if ((typeof el.data('show-value') == 'undefined') || el.data('show-value'))
                el.html(el.data('value') ? el.data('value') : e);
        });
    };


    module.initMotionOne = function () {
        const motion = require('motion');

        // Select all items you want to animate
        const items = $('.animate-card');

        // Use IntersectionObserver to trigger the animation when they enter the viewport
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    let selector = $(entry.target); // The element being observed

                    console.log(`Animating target: ${selector}`); // Debug log

                    if (selector.length) {
                        console.log('Target element found, applying animation'); // Debug log

                        // Animate multiple items with staggered delay
                        motion.animate(".animate-card", {
                            opacity: 1,       // Set opacity to 1 (fully visible)
                            y: [50, 0]        // Move items from y = 50px to y = 0px (move up)
                        }, {
                            delay: motion.stagger(0.35)  // Stagger the animation by 0.05 seconds
                        });

                        observer.unobserve(entry.target); // Stop observing after animation
                    }
                }
            });
        }, {threshold: 0.5}); // Trigger when 50% of the element is visible

        // Observe each item
        items.each(function () {
            observer.observe(this);
        });

///


        const boxes = document.querySelectorAll('.box');

        window.addEventListener('scroll', () => {
            // Get scroll position (pixels from top)
            const scrollTop = window.scrollY;

            // Calculate how much to move (1em = 16px usually)
            const moveX = scrollTop * 0.1; // Move slower, tweak multiplier as needed

            // Apply transform to each box
            boxes.forEach((box, index) => {
                box.style.transform = `translateX(${moveX}px)`;
            });
        });


    };

    module.mainMenuController = function () {
        const toggleBtn = document.getElementById("burgerToggle");
        const menu = document.querySelector(".menu-container");

        let menuOpen = false;

        function openMenu() {
            const fullHeight = menu.scrollHeight;

            // Set to exact height to trigger transition
            menu.style.height = fullHeight + "px";
            menu.classList.add("open");
            menu.classList.remove("closing");

            menuOpen = true;
        }

        function closeMenu() {
            const currentHeight = menu.scrollHeight;

            // Set current height to start transition from current state
            menu.style.height = currentHeight + "px";

            // Trigger reflow to apply the style before collapsing
            void menu.offsetHeight;

            // Then collapse to 0
            menu.style.height = "0";
            menu.classList.add("closing");
            menu.classList.remove("open");

            menuOpen = false;
        }

        toggleBtn.addEventListener("click", () => {
            if (menuOpen) {
                closeMenu();
            } else {
                openMenu();
            }
        });

        menu.addEventListener("transitionend", (e) => {
            if (e.propertyName === "height") {
                if (menuOpen) {
                    // After expanding, allow dynamic resizing
                    menu.style.height = "auto";
                } else {
                    // After collapsing, clean up
                    menu.classList.remove("closing");
                }
            }
        });
    };


    module.rangeSlider = function () {

        const mileageSlider = document.getElementById('mileage');

        function updateGradient(slider) {
            const min = parseInt(slider.min);
            const max = parseInt(slider.max);
            const value = parseInt(slider.value);

            const percentage = ((value - min) / (max - min)) * 100;

            // Filled portion: gradient from light to dark orange
            const fillGradient = `linear-gradient(90deg, #ffa726 0%, #fb8c00 ${percentage}%, #333 ${percentage}%, #333 100%)`;

            slider.style.background = fillGradient;
        }

        mileageSlider.addEventListener('input', () => {
            updateGradient(mileageSlider);
        });

// Initialize the gradient on page load
        updateGradient(mileageSlider);

    };


    return module;

};
